import useEnv from '~/hooks/useEnv';

const Disclaimer = () => {
  const env = useEnv();

  return (
    <div className="mr-auto">
      <p className="text-sm text-light-grey">
        We may earn a commission when you buy something from links on this page.
        <a
          className="ml-2 text-sm font-semibold text-dark-grey underline"
          href={`${env.SITE_BASE_URL}/about#editorial-policy`}
          aria-label="Learn more about our editorial policy"
        >
          Learn More
        </a>
      </p>
    </div>
  );
};

export default Disclaimer;
